import { browse } from "./browse/i18n";
import { search } from "./search/i18n";
import { downloads } from "./downloads/i18n";
import { gold } from "./gold/i18n";
import { inbox } from "./inbox/components/i18n";
import { library } from "./library/i18n";
import { hub } from "./news/i18n";
import { gift } from "./gift/i18n";
import { reader } from "./reader/i18n";
import { root } from "./root/i18n";
import { artist } from "./artist/i18n";
import { redemptionSuccess } from "./redemptionSuccess/i18n";
import { adminNext } from "./adminNext/i18n";
import { blackFriday } from "./blackFriday/i18n";
import { holidayBundle } from "./holidayBundle/i18n";
import { ultimateXmenBundle } from "./ultimateXmenBundle/i18n";
import { purchases } from "./purchases/i18n";
import { shelf } from "./shelf/i18n";
import { monthlyComics } from "./monthlyComics/i18n";
import { settings } from "./settings/i18n";

// Roll up screen language files to create a "screens.{screen}" path
export const screens = {
  browse,
  search,
  downloads,
  hub,
  inbox,
  reader,
  library,
  gold,
  gift,
  root,
  artist,
  redemptionSuccess,
  adminNext,
  blackFriday,
  holidayBundle,
  ultimateXmenBundle,
  purchases,
  shelf,
  monthlyComics,
  settings,
};
